import React from 'react';
import PageHeader from '../components/HeroSection';
import ContactSection from '../components/ContactSection';
import BookSection from '../components/BookSection';
import { Helmet } from 'react-helmet';
const AboutPage = () => {
  // Reusable font styles to eliminate repetition
  const fontStyles = {
    quentin: {
      fontFamily: 'Quentin',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '160px',
      lineHeight: '100%',
      letterSpacing: '0%',
      textAlign: 'center'
    },
    montserratBold: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      fontStyle: 'normal',
      textTransform: 'uppercase'
    },
    montserratRegular: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 400,
      fontStyle: 'normal'
    },
    montserratSemiBold: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      fontStyle: 'SemiBold'
    },
    quentinRegular: {
      fontFamily: 'Quentin',
      fontWeight: 400,
      fontStyle: 'Regular',
      fontSize: '20px',
      lineHeight: '100%',
      letterSpacing: '20%',
      textAlign: 'right'
    },
    actionButton: {
      width: '150px',
      height: '25px',
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontStyle: 'Bold',
      fontSize: '16px',
      lineHeight: '156%',
      letterSpacing: '3.2px',
      textAlign: 'center',
      textTransform: 'uppercase',
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      textDecorationOffset: '0%',
      textDecorationThickness: '0%',
      color: '#C7A064'
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
  <title>About Our Salon | Hair to Dye For – Easton, PA</title>
  <meta name="description" content="Get to know our stylists and what makes Hair to Dye For a trusted name in Easton for extensions, color, and creative hair transformations." />
  <meta property="og:title" content="About Our Stylists | Hair to Dye For, Easton" />
  <meta property="og:description" content="Our experienced team brings passion and precision to every service. Learn more about our story and stylist specialties." />
  <meta property="og:url" content="https://www.hairtodyeforeaston.com/about" />
  <meta property="og:type" content="website" />
  <meta name="keywords" content="hair stylists Easton PA, Hair to Dye For team, salon Easton PA, extension specialists" />
  <link rel="canonical" href="https://www.hairtodyeforeaston.com/about" />
</Helmet>
      {/* Page Header with Hero */}
      <PageHeader pageTitle="ABOUT" />

     {/* Our Story Section - FIXED RESPONSIVE LAYOUT */}
<section className="py-10 md:py-16 lg:py-20">
  <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-[116px]">
    <h1 className="sr-only">Meet the Team Behind Hair to Dye For</h1>
    {/* Main Container */}
    <div className="relative w-full max-w-[1620px] mx-auto">
      
      {/* Damask Background Image - Better positioning for all screens */}
      <div className="absolute z-0 pointer-events-none
                    w-[320px] h-[320px] 
                    sm:w-[420px] sm:h-[420px] 
                    md:w-[500px] md:h-[500px] 
                    lg:w-[580px] lg:h-[580px]
                    xl:w-[642px] xl:h-[629px]
                    top-[200px] 
                    sm:top-[220px]
                    md:top-[180px] 
                    lg:top-[150px] 
                    xl:top-[100px]
                    left-[50%]
                    md:left-[55%]
                    lg:left-[52%]
                    xl:left-[50%]
                    transform -translate-x-1/2
                    opacity-50 sm:opacity-60 md:opacity-70 lg:opacity-85 xl:opacity-100">
        <img 
          src={require('../assets/images/White_damask.webp')} 
          alt="Damask Background"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Welcome Text Container - Better spacing for medium screens */}
      <div className="relative z-10 mb-8 md:mb-12 lg:mb-16">
        {/* Welcome To - Background text */}
        <h2 className="text-[80px] 
                     sm:text-[100px] 
                     md:text-[120px] 
                     lg:text-[140px] 
                     xl:text-[160px]
                     leading-[100%] 
                     text-center md:text-left"
            style={{
              fontFamily: 'Quentin',
              fontWeight: 400,
              fontStyle: 'normal',
              color: '#F2EADC',
              letterSpacing: '0%'
            }}>Welcome To</h2>
        
        {/* HAIR TO DYE FOR - Overlay text */}
        <h3 className="text-[32px] 
                     sm:text-[40px] 
                     md:text-[48px] 
                     lg:text-[56px] 
                     xl:text-[64px]
                     leading-[100%] 
                     text-center md:text-left
                     -mt-[50px] sm:-mt-[60px] md:-mt-[70px] lg:-mt-[85px] xl:-mt-[95px]
                     md:ml-[200px] lg:ml-[250px] xl:ml-[300px]"
            style={{ 
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              fontStyle: 'normal',
              textTransform: 'uppercase',
              letterSpacing: '4%'
            }}>HAIR TO DYE FOR</h3>
      </div>
     
      {/* Content Container - FIXED 3-SECTION LAYOUT */}
      <div className="relative z-20 px-4 sm:px-8 md:px-0">
        
        {/* Mobile Layout - Stacked */}
        <div className="flex flex-col items-center gap-6 md:hidden">
          {/* Mobile: Image First */}
          <div className="w-[140px] h-[140px] 
                        sm:w-[160px] sm:h-[160px]
                        rounded-full overflow-hidden flex-shrink-0">
            <img 
              src={require('../assets/images/AboutGwenImage.webp')} 
              alt="Gwen Crouse - Owner & Artistic Director"
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Mobile: Gwen's Info */}
          <div className="text-center">
            <h4 className="text-[16px]"
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 400,
                  letterSpacing: '.2em',
                  textTransform: 'uppercase',
                  color: '#C7A064',
                  lineHeight: '100%'
                }}>GWEN CROUSE</h4>
            <p className="text-[18px] mt-2 whitespace-nowrap uppercase"
               style={{
                 fontFamily: 'Montserrat, sans-serif',
                 fontWeight: 600,
                 color: '#000000',
                 letterSpacing: '.2em',
                 lineHeight: '100%'
               }}>Owner & Artistic Director</p>
          </div>
          
          {/* Mobile: Description */}
          <div>
            <p className="text-left mb-4 text-[14px]"
               style={{
                 fontFamily: 'Montserrat, sans-serif',
                 fontWeight: 400,
                 lineHeight: '156%',
                 letterSpacing: '0%'
               }}>
              Hair To Dye For is the Lehigh valley's premier extension and color lounge. Since 2005 we have been setting the bar with unique personalized style. From lived in blonde to balayage to electric pink, we got you covered! We offer a wide variety of luxury extensions to elevate your look. Sit back, relax and enjoy a glass of wine as we work, our magic! We can't wait to meet you!
            </p>
            <p className="text-left text-[14px]"
               style={{
                 fontFamily: 'Montserrat, sans-serif',
                 fontWeight: 700,
                 lineHeight: '156%',
                 letterSpacing: '0%'
               }}>
              Experience what it's like to truly love your hair.
            </p>
          </div>
        </div>

        {/* Desktop/Tablet Layout - 3 Columns Side by Side */}
        <div className="hidden md:flex items-start justify-between gap-6 lg:gap-8 xl:gap-12 md:px-8 lg:px-12 xl:px-16">
          
          {/* Left: Gwen's Info (Text Only) */}
          <div className="flex-shrink-0 text-right pt-4 lg:pt-8">
            <h4 className="text-[16px] md:text-[17px] xl:text-[18px]"
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 400,
                  letterSpacing: '.2em',
                  textTransform: 'uppercase',
                  color: '#C7A064',
                  lineHeight: '100%'
                }}>GWEN CROUSE</h4>
            <p className="text-[18px] md:text-[19px] xl:text-[20px] 
                        mt-2 sm:mt-3
                        whitespace-nowrap uppercase"
               style={{
                 fontFamily: 'Montserrat, sans-serif',
                 fontWeight: 600,
                 color: '#000000',
                 letterSpacing: '.2em',
                 lineHeight: '100%'
               }}>Owner & Artistic Director</p>
          </div>
          
          {/* Center: Image Only */}
          <div className="flex-shrink-0 w-[160px] h-[160px] 
                        lg:w-[170px] lg:h-[170px] 
                        xl:w-[176px] xl:h-[176px]
                        rounded-full overflow-hidden">
            <img 
              src={require('../assets/images/AboutGwenImage.webp')} 
              alt="Gwen Crouse - Owner & Artistic Director"
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Right: Description Only */}
          <div className="flex-1 max-w-[600px] pt-4 lg:pt-8">
            <p className="text-left mb-4 
                        text-[14px] md:text-[15px] xl:text-[16px]"
               style={{
                 fontFamily: 'Montserrat, sans-serif',
                 fontWeight: 400,
                 lineHeight: '156%',
                 letterSpacing: '0%'
               }}>
              Hair To Dye For is the Lehigh valley's premier extension and color lounge. Since 2005 we have been setting the bar with unique personalized style. From lived in blonde to balayage to electric pink, we got you covered! We offer a wide variety of luxury extensions to elevate your look. Sit back, relax and enjoy a glass of wine as we work, our magic! We can't wait to meet you!
            </p>
            <p className="text-left text-[14px] md:text-[15px] xl:text-[16px]"
               style={{
                 fontFamily: 'Montserrat, sans-serif',
                 fontWeight: 700,
                 lineHeight: '156%',
                 letterSpacing: '0%'
               }}>
              Experience what it's like to truly love your hair.
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  
  {/* Extended White Background Spacing */}
  <div className="w-full h-[60px] md:h-[80px] lg:h-[100px] xl:h-[120px] bg-white"></div>
</section>

      {/* Book Section */}
      <BookSection />

      {/* Contact Section */}
      <ContactSection />
    </div>
  );
};

export default AboutPage;